module.exports = __webpack_public_path__ + "img/exam.ce035eb7.svg";